import { getDefaultPopoverRoot } from '../../hooks/usePopoverRoot';
let size = -1;

/**
 * Determine size of browser-provided scrollbar
 * @param recalculate whether to bust the cached size.
 * @default false
 */
export function getScrollbarSize(recalculate = false) {
  if (size === -1 || recalculate) {
    // use the default Popover root to ensure the test div has the correct scrollbar styles
    const parent = getDefaultPopoverRoot();
    const div = document.createElement('div');
    const style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    parent.appendChild(div);
    size = Math.ceil(div.offsetWidth - div.clientWidth);
    parent.removeChild(div);
  }
  return size;
}
//# sourceMappingURL=getScrollbarSize.js.map